<template>
    <component :is="tag">
        <slot
            :basket-data="basketData"
            :total-items="totalItems"
        />
    </component>
</template>

<script>
import { EVENT_ADD_TO_CART } from '../../services/event-bus/event-types';

const { eventBus } = window.specialtyApp;

export default {
    name: 'app-basket',

    inject: ['$basketService'],

    props: {
        tag: {
            type: String,
            default: 'div',
        },
    },

    methods: {
        addToBasketHandler(payload) {
            this.$emit('addToBasket', payload);
        },

        initEventHandling() {
            eventBus.$on(EVENT_ADD_TO_CART, this.addToBasketHandler);
        },
    },

    computed: {
        basketData() {
            return this.$basketService.state.basketData;
        },

        totalItems() {
            return Object.values(this.basketData?.BASKET?.ITEMS || {}).reduce(
                (accum, current) => accum + current.QUANTITY,
                0,
            );
        },
    },

    mounted() {
        this.initEventHandling();
    },
};
</script>
